import { render, staticRenderFns } from "./TextAreaEnhanced.vue?vue&type=template&id=29c24bf4&"
import script from "./TextAreaEnhanced.vue?vue&type=script&lang=ts&"
export * from "./TextAreaEnhanced.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c24bf4')) {
      api.createRecord('29c24bf4', component.options)
    } else {
      api.reload('29c24bf4', component.options)
    }
    module.hot.accept("./TextAreaEnhanced.vue?vue&type=template&id=29c24bf4&", function () {
      api.rerender('29c24bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/TextAreaEnhanced.vue"
export default component.exports